export const CHAR_SIZE = {
  [12]: 8,
};

export function labelSize(
  labels: string[],
  fontSize: keyof typeof CHAR_SIZE = 12
) {
  const maxCharCount = labels.reduce((max, label) => {
    const value = label === "__VZBL::null__" ? "n/a" : label;
    return Math.max(`${value}`.trim().length, max);
  }, 0);
  return maxCharCount * CHAR_SIZE[fontSize];
}

export function labelRotate(
  neededWidth: number,
  constrainedWidth: number,
  fontSize: keyof typeof CHAR_SIZE = 12
) {
  const labelHeight = (fontSize * 4) / 3;
  const rotationNeeded = constrainedWidth < neededWidth;
  const radians = rotationNeeded
    ? Math.acos(constrainedWidth / neededWidth)
    : 0;
  const angle = Math.round(0 - radians * (180 / Math.PI));
  const rise = Math.round(neededWidth * Math.sin(radians) + labelHeight);
  return { angle, rise };
}
